import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from '../locales/en.json'
import sk from '../locales/sk.json'
import cs from '../locales/cs.json'
import de from '../locales/de.json'
import es from '../locales/es.json'
import fr from '../locales/fr.json'

// Migrate legacy campfire_language key → mori_language (one-time, safe to leave)
if (typeof localStorage !== 'undefined') {
  const legacy = localStorage.getItem('campfire_language')
  if (legacy && !localStorage.getItem('mori_language')) {
    localStorage.setItem('mori_language', legacy)
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      sk: { translation: sk },
      cs: { translation: cs },
      de: { translation: de },
      es: { translation: es },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'mori_language',
      caches: ['localStorage'],
    },
  })

export default i18n
